import {Component, Prop, Vue} from 'vue-property-decorator';
import {TableHeader} from '@/model/CommonModel';
import UserApi from '@/api/UserApi';

@Component
export default class FilterMixin extends Vue {
    @Prop() protected tableHeader: TableHeader;
    @Prop({default: ''}) protected menuId: string;
    
    protected loading: boolean = false;
    protected visible: boolean = false;
    
    get filterId() {
        return `${this.tableHeader.columnId}_FILTER`;
    }
    
    protected onCancel() {
        this.visible = false;
    }
    
    protected onDelete() {
        UserApi.deleteUserFilters(this.menuId, this.tableHeader.columnId)
               .then((res: any) => {
                   this.visible = false;
                   this.$emit('refresh');
               });
    }
}
